import { render, staticRenderFns } from "./RefereeForm.vue?vue&type=template&id=1cba8cb0&scoped=true&"
import script from "./RefereeForm.vue?vue&type=script&lang=js&"
export * from "./RefereeForm.vue?vue&type=script&lang=js&"
import style0 from "./RefereeForm.vue?vue&type=style&index=0&id=1cba8cb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cba8cb0",
  null
  
)

export default component.exports